export const listTemplates = '/my-products'

const soldTemplateDetailsBase = '/products/sold'

export const templatePage = (templateId: string): string =>
	`${soldTemplateDetailsBase}/${templateId}`
